module.exports = __webpack_public_path__ + "static/img/environment.74a43315.png";